/** Public marketing site — hosted separately from this app. */
export const MARKETING_SITE = "https://llmgenerator.com";

/** Contact form on the marketing site (preferred over mailto: links). */
export const CONTACT_URL = `${MARKETING_SITE}/contact`;

export const DOCS_URL = "https://docs.llmgenerator.com/";
